import { useLocation, useNavigate } from 'react-router-dom';

import { useFilterStore } from '@/entities/discovery';
import { useSearchStore } from '@/entities/search';

import { buildSearchURL } from '@/features/dataSearch/lib';

export const useSearchExecution = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { setQuery, setSortBy } = useSearchStore.getState();
  const { filters } = useFilterStore();

  const execute = (searchValue: string) => {
    const trimmed = searchValue.trim();
    setQuery(trimmed);

    if (trimmed === '') {
      setSortBy('lastUpdated');
    }

    if (location.pathname !== '/search') {
      const url = buildSearchURL(trimmed, filters);
      navigate(url);
    }
  };

  return {
    execute,
  };
};
